import { motion } from "framer-motion";
import { IMAGES } from "@/data/site";
import { Handshake, Calendar, GraduationCap, ArrowRight } from "lucide-react";

const ctas = [
    {
        icon: Handshake,
        title: "Become A Partner",
        desc: "Districts, community orgs, and youth programs — bring YMP to your campus.",
        action: "partner",
    },
    {
        icon: Calendar,
        title: "Schedule A Meeting",
        desc: "Sit down with our team. Tour a cohort. See the program in motion.",
        action: "meeting",
    },
    {
        icon: GraduationCap,
        title: "Sponsor A Program",
        desc: "Fund a full 9-week Accelerator Program from intake to final stage.",
        action: "sponsor",
    },
];

export const Partnership = ({ onPartner }) => {
    const handleClick = (action) => onPartner(action);

    return (
        <section
            id="partners"
            data-testid="partnership-section"
            className="relative py-12 md:py-16 bg-[#050505] overflow-hidden"
        >
            <div
                className="absolute inset-0 opacity-20 pointer-events-none"
                style={{
                    backgroundImage: `url(${IMAGES.goldTexture})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    mixBlendMode: "screen",
                }}
            />
            <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-transparent to-[#050505]" />

            <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 relative">
                <div className="max-w-3xl">
                    <span className="text-xs uppercase tracking-[0.4em] text-[#D4AF37] font-bold">
                        / 08 — Partnership
                    </span>
                    <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-7xl uppercase tracking-tight leading-[0.92]">
                        Bring The
                        <br />
                        <span className="gold-text-gradient">
                            Young Mogul Experience
                        </span>
                        <br />
                        To Your Campus.
                    </h2>
                    <p className="mt-8 text-white/70 leading-relaxed text-base md:text-lg max-w-xl">
                        We partner with school districts, community
                        organizations, sponsors, and entertainment industry
                        professionals who want to invest in the next generation
                        of creators.
                    </p>
                </div>

                <div className="mt-16 grid md:grid-cols-3 gap-5">
                    {ctas.map((c, i) => (
                        <motion.button
                            key={c.title}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: i * 0.12 }}
                            whileHover={{ y: -6 }}
                            onClick={() => handleClick(c.action)}
                            data-testid={`partnership-cta-${i}`}
                            className="text-left group relative overflow-hidden border border-white/10 bg-[#0A0A0A] p-8 hover:border-[#D4AF37] transition-all duration-500 hover:gold-glow"
                        >
                            <c.icon className="text-[#D4AF37]" size={36} />
                            <h3 className="mt-6 font-display text-2xl md:text-3xl uppercase tracking-tight leading-tight text-white">
                                {c.title}
                            </h3>
                            <p className="mt-4 text-sm text-white/65 leading-relaxed">
                                {c.desc}
                            </p>
                            <div className="mt-8 flex items-center gap-3 text-[#D4AF37] text-xs uppercase tracking-[0.3em] font-bold">
                                Start The Conversation
                                <ArrowRight
                                    size={14}
                                    className="group-hover:translate-x-1 transition-transform"
                                />
                            </div>
                            <div className="absolute top-4 right-4 font-display text-5xl text-[#D4AF37]/10">
                                0{i + 1}
                            </div>
                        </motion.button>
                    ))}
                </div>
            </div>
        </section>
    );
};
